import './src/styles/global.css';

import React from 'react';

export const wrapRootElement = ({ element }) => {
  return element;
};